import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { disconnectGmail, listGmailConnections, startGmailConnect } from '../lib/userGmailApi';

export function useUserGmail(userId: string | undefined) {
  return useQuery({
    queryKey: ['userGmail', userId],
    queryFn: () => listGmailConnections(userId as string),
    enabled: Boolean(userId),
  });
}

// Starts the OAuth flow: requests the consent URL then hard-redirects the
// browser to Google. The callback returns the user to /people/:id?gmail=...
export function useConnectGmail(userId: string) {
  return useMutation({
    mutationFn: (label?: string) => startGmailConnect(userId, label),
    onSuccess: ({ authUrl }) => {
      window.location.href = authUrl;
    },
  });
}

export function useDisconnectGmail(userId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (connectionId: string) => disconnectGmail(userId, connectionId),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['userGmail', userId] });
    },
  });
}
